import React, { Component } from "react";
import { Input, Label, Button, Alert, Col, Row, Collapse } from "reactstrap";
import Steps from "../../../components/Steps/Steps";
import {
  GENDER_PRONOUNS_OPTIONS,
  isTrivvyProduct,
  officeSetupSteps,
  profilePicValidityCheck,
  isTrivvyUrl,
  formatPhoneNumber,
} from "../../../utils/constants";
import axios from "../../../axios";
import { connect } from "react-redux";
import moment from "moment";
import avatarIcon from "../../../assets/default-avatar.png";
import DatePicker from "react-datepicker";
import { genderMapOptions } from "../../../utils/constants";
import Select from "react-select";
import * as actionCreators from "../../../modules/actions/index";
import * as url from "../../../utils/url";
import { dataURLtoFile } from "../../../utils/stringUtils";
import findIndex from "lodash/findIndex";
import PhoneInput from "react-phone-number-input";

import {
  validateOfficeSetupPersonalDetails,
  isValidExtension,
} from "../../../utils/validations";
import Loading from "../../../hoc/Loading/Loading";
import rightArrow from "./../../../assets/arrow-right.png";
// import profilePhoto0 from './../../../assets/user-image-plc/User_Icon_1.png';
// import profilePhoto1 from './../../../assets/user-image-plc/User_Icon_2.png';
// import profilePhoto2 from './../../../assets/user-image-plc/User_Icon_3.png';
// import profilePhoto3 from './../../../assets/user-image-plc/User_Icon_4.png';
import TooltipDefinition from "../../../components/UI/TooltipDefinition/TooltipDefinition";
import If from "../../../components/Shared/If";
import { isMobile } from "../../../utils/deviceInfo";
import AutocompleteAddress from "../../../components/AddressSearch/AutocompleteAddress";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

const diversityTypes = [
  "occupation",
  "seniority",
  "religion",
  "veteran",
  "disability",
  "sexualOrientation",
  "ethnicity",
  "gender",
  "address",
  "genderPronoun",
];
let profilePhoto0 =
    "https://dev-oo-app-attachment.s3.us-east-2.amazonaws.com/static_photos/User_Icon_1.png",
  profilePhoto1 =
    "https://dev-oo-app-attachment.s3.us-east-2.amazonaws.com/static_photos/User_Icon_2.png",
  profilePhoto2 =
    "https://dev-oo-app-attachment.s3.us-east-2.amazonaws.com/static_photos/User_Icon_3.png",
  profilePhoto3 =
    "https://dev-oo-app-attachment.s3.us-east-2.amazonaws.com/static_photos/User_Icon_4.png";

let userPicPlaceholders = [
  profilePhoto0,
  profilePhoto1,
  profilePhoto2,
  profilePhoto3,
];

class PersonalDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      firstName: this.props.user.profile.firstName
        ? this.props.user.profile.firstName
        : "",
      lastName: this.props.user.profile.lastName
        ? this.props.user.profile.lastName
        : "",
      dIRole: this.props.user.profile.dIRole
        ? this.props.user.profile.dIRole
        : "",
      title: this.props.user.profile.title ? this.props.user.profile.title : "",
      recentUsers: { userCount: 0, userList: [] },

      gender: {
        value: null,
        options: genderMapOptions.filter((e) => e.label !== "All"),
      },
      profilePicUrl: null,
      profilePic: null,
      ethnicity: {
        value: null,
        options: [],
      },
      birthDate: null,
      sexualOrientation: {
        value: null,
        options: [],
      },
      occupation: {
        value: null,
        options: [],
      },
      seniority: {
        value: null,
        options: [],
      },
      veteran: {
        value: null,
        options: [],
      },
      disability: {
        value: null,
        options: [],
      },
      religion: {
        value: null,
        options: [],
      },
      picIndex: Math.floor(Math.random() * 4),
      mobileNumber: this.props.user.profile.mobileNumber || "",
      address: {
        value: this.props.user.profile.address || undefined,
        updatedValue: this.props.user.profile.address || undefined,
        error: false,
      },
      location: {
        value: this.props.user.profile.location || undefined,
        updatedValue: this.props.user.profile.location || undefined,
        error: false,
      },
      genderPronoun: {
        value: this.props.user.profile.genderPronoun || undefined,
        updatedValue: this.props.user.profile.genderPronoun || undefined,
        error: false,
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let religion = [],
      sexualOrientation = [],
      veteran = [],
      disability = [],
      ethnicity = [],
      seniority = [],
      occupation = [];
    var that = this;
    axios
      .all([axios.get(url.getDiversityTypes), axios.get(url.getRecentUsers)])
      .then(
        axios.spread(function(diversity, recentU) {
          let divResp = diversity.data.data;
          divResp.map((e) => {
            if (e.categoryGrouping === "VETERAN") {
              veteran.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            } else if (e.categoryGrouping === "SEXUAL ORIENTATION") {
              sexualOrientation.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            } else if (e.categoryGrouping === "DISABILITY") {
              disability.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            } else if (e.categoryGrouping === "RELIGION") {
              religion.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            } else if (e.categoryGrouping === "ETHNICITY") {
              ethnicity.push({
                value: e._id,
                label: e.name,
                definition: e.definition,
              });
            } else if (e.categoryGrouping === "SENIORITY") {
              if (e.name != "All") {
                seniority.push({
                  value: e._id,
                  label: e.name,
                  definition: e.definition,
                });
              }
            } else if (e.categoryGrouping === "OCCUPATION") {
              if (e.name != "All") {
                occupation.push({
                  value: e._id,
                  label: e.name,
                  definition: e.definition,
                });
              }
            }
          });

          let recentResp = recentU.data.data;

          that.setState((prevState) => ({
            recentUsers: {
              userCount: recentResp.userCount,
              userList: recentResp.userList,
            },
            ethnicity: { ...prevState.ethnicity, options: ethnicity },
            religion: { ...prevState.religion, options: religion },
            veteran: { ...prevState.veteran, options: veteran },
            disability: { ...prevState.disability, options: disability },
            seniority: { ...prevState.seniority, options: seniority },
            occupation: { ...prevState.occupation, options: occupation },
            sexualOrientation: {
              ...prevState.sexualOrientation,
              options: sexualOrientation,
            },
          }));
        })
      )
      .catch((error) => {
        console.log(error);
      });

    // axios.get(url.getDiversityTypes).then(({data}) => {
    //   console.log('res---', data)
    //   let resp = data.data
    //   resp.map(e=> {
    //     if(e.categoryGrouping === 'VETERAN'){
    //       veteran.push({value: e._id, label:e.name, definition: e.definition})
    //     }else if(e.categoryGrouping === 'SEXUAL ORIENTATION'){
    //       sexualOrientation.push({value: e._id, label:e.name, definition: e.definition})
    //     }else if(e.categoryGrouping === 'DISABILITY'){
    //       disability.push({value: e._id, label:e.name, definition: e.definition})
    //     }else if(e.categoryGrouping === 'RELIGION'){
    //       religion.push({value: e._id, label:e.name, definition: e.definition})
    //     }else if(e.categoryGrouping === 'ETHNICITY'){
    //       ethnicity.push({value: e._id, label:e.name, definition: e.definition})
    //     }else if(e.categoryGrouping === 'SENIORITY'){
    //       if(e.name!="All"){
    //         seniority.push({value: e._id, label:e.name, definition: e.definition})
    //       }
    //     }else if(e.categoryGrouping === 'OCCUPATION'){
    //       if(e.name!="All"){
    //         occupation.push({value: e._id, label:e.name, definition: e.definition})
    //       }
    //     }
    //   })
    // this.setState( (prevState) => ({
    //   ethnicity: {...prevState.ethnicity, options: ethnicity},
    //   religion: {...prevState.religion, options: religion},
    //   veteran: {...prevState.veteran, options: veteran},
    //   disability: {...prevState.disability, options: disability},
    //   seniority: {...prevState.seniority, options: seniority},
    //   occupation: {...prevState.occupation, options: occupation},
    //   sexualOrientation: {...prevState.sexualOrientation, options:sexualOrientation},
    // }))
    // })

    // axios.get(url.getRecentUsers).then(({data}) => {
    //   console.log(data.data)
    //   this.setState({recentUsers: {userCount:data.data.userCount,userList:data.data.userList}})
    // })
  }

  renderUsers = () => {
    let { recentUsers } = this.state;

    // console.log('testing---', recentUsers)
    let joinUserCount = recentUsers.userCount - recentUsers.userList.length;
    joinUserCount = parseInt(joinUserCount);
    // console.log('new---', joinUserCount)

    if (joinUserCount < 21) {
      // console.log("inside-----")
      joinUserCount = "10";
    } else if (joinUserCount > 20 && joinUserCount < 31) {
      joinUserCount = "20";
    } else if (joinUserCount > 30 && joinUserCount < 41) {
      joinUserCount = "30";
    } else if (joinUserCount > 40 && joinUserCount < 51) {
      joinUserCount = "40";
    } else if (joinUserCount > 50 && joinUserCount < 61) {
      joinUserCount = "50";
    } else if (joinUserCount > 60 && joinUserCount < 71) {
      joinUserCount = "60";
    } else if (joinUserCount > 70 && joinUserCount < 81) {
      joinUserCount = "70";
    } else if (joinUserCount > 80 && joinUserCount < 91) {
      joinUserCount = "80";
    } else if (joinUserCount > 90 && joinUserCount < 101) {
      joinUserCount = "90";
    } else {
      joinUserCount = "100";
    }

    if (
      recentUsers &&
      recentUsers.userList &&
      recentUsers.userList.length > 0
    ) {
      return (
        <div className="displayInlineBlock">
          {recentUsers.userList.map((e) => {
            return (
              <div
                className="img-container marginLeft30 displayInlineBlock"
                key={e._id}
              >
                <img
                  src={
                    profilePicValidityCheck(e.profilePic)
                      ? e.profilePic
                      : avatarIcon
                  }
                  className="officemate-profile-img"
                />
              </div>
            );
          })}

          {recentUsers && recentUsers.userCount && recentUsers.userCount > 5 ? (
            <div className="marginLeft30 recentUserCount">
              <span className="recentUserTotalTxt">
                <span> {joinUserCount} +</span>
              </span>
            </div>
          ) : null}
        </div>
      );
    }
  };

  updateDiversity = (value, obj) => {
    // console.log('val---',value)
    obj["value"] = value;
    this.setState({ obj });
  };

  handleInputChange = ({ target }) => {
    const { name, value } = target;
    this.setState({
      [name]: value,
    });
  };

  handleContinue = () => {
    const formData = new FormData();
    let {
      firstName,
      lastName,
      dIRole,
      title,
      profilePic,
      disability,
      religion,
      veteran,
      sexualOrientation,
      ethnicity,
      gender,
      occupation,
      seniority,
      birthDate,
      profilePhoto0,
      profilePhoto1,
      profilePhoto2,
      profilePhoto3,
      address,
      location,
      genderPronoun,
      mobileNumber,
      collapseOpen,
    } = this.state;
    let data = {
      firstName,
      lastName,
      dIRole,
      title,
      profilePic,
      disability,
      religion,
      veteran,
      sexualOrientation,
      ethnicity,
      gender,
      occupation,
      seniority,
      birthDate,
      address,
      location,
      genderPronoun,
      mobileNumber,
    };

    const errorFields = validateOfficeSetupPersonalDetails(data);
    if (errorFields.length > 0) {
      window.scroll(0, 0);
      this.setState({
        formError: true,
        formErrorFields: errorFields,
      });
      // console.log(errorFields);
      return;
    } else {
      this.setState({
        formError: false,
        formErrorFields: [],
      });
    }
    for (let key in data) {
      // console.log('key----', key)

      if (key === "mobileNumber") {
        // console.log('data----', data)
        if (data[key] && data[key] != null && data[key] != undefined) {
          formData.append("mobileNumber", data[key]);
        }
        // if(data[key]) {
        //   formData.append('profilePic',data[key]);
        // } else {
        //   formData.append('profilePic',userPicPlaceholders[idx]);
        // }
      } else if (key === "profilePic") {
        // console.log('data----', data)
        if (data[key] && data[key] != null && data[key] != undefined) {
          formData.append("profilePic", data[key]);
        }
        // if(data[key]) {
        //   formData.append('profilePic',data[key]);
        // } else {
        //   formData.append('profilePic',userPicPlaceholders[idx]);
        // }
      } else if (key === "location") {
        formData.append(key, JSON.stringify(data[key].value));
      } else {
        if (diversityTypes.indexOf(key) > -1) {
          // console.log(data[key])
          if (key !== "address") {
            if (
              data[key].value ||
              (key == "genderPronoun" && data[key].value >= 0)
            ) {
              formData.append(key, JSON.stringify(data[key].value));
            } else {
              formData.append(key, null);
            }
          } else {
            console.log(key);
            if (data[key].value) {
              formData.append(key, data[key].value);
            } else {
              formData.append(key, "");
            }
          }
        } else {
          // console.log(key, data[key])
          formData.append(key, data[key]);
        }
      }
    }

    console.log(formData.get("address"), formData.get("genderPronoun"));

    formData.append("isProfileDetailsUpdated", true);
    // Display the key/value pairs
    // console.log('form ---- ', formData)
    // return
    let that = this;
    axios
      .put(url.updateUser, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        console.log("profileData-----", data.data);
        let profileData = data.data;
        const { profile } = that.props.user;
        // console.log(profile)

        that.props.onUpdateUserSuccess(data.data);

        if (
          profile.organizationId &&
          (profile.organizationId.isSignedUpFromTrivvyWebsite ||
            isTrivvyUrl(profile.organizationId))
        ) {
          that.props.history.push(
            `/home/trivia/${profile.organizationId._id}/list`
          );
        } else {
          if (profile.organizationId && profile.organizationId.startPage) {
            console.log("start PAGE");
            that.props.history.push(profile.organizationId.startPage);
          } else {
            console.log("home/stories PAGE");

            console.log("log ---- ", that.props);
            that.props.history.push("/home/stories");
          }
        }
      })
      .catch((error) => {
        //this.setState({ ...this.state, errorMessage: error.response.data });
        console.log("error---", error);
      });
  };

  handleProfilePicUpload = (event) => {
    // console.log("insied up")
    // console.log("event---", event.target.files)
    let profilePic = event.target.files[0];

    // let profilePicExt = profilePic.name.split('.')[profilePic.name.split('.').length - 1];
    let profilePicUrl = URL.createObjectURL(event.target.files[0]);
    // console.log(profilePicUrl,'----', profilePic)
    // if(!['png', 'jpg', 'jpeg'].includes(profilePicExt.toLowerCase())) {
    //   this.setState({ profilePicUrl: undefined, profilePic: {value: this.props.user.profilePic, error: true, errorMessage: 'Only .png and .jpg files are allowed.'}});
    // } else if(profilePic.size > (1024 * 1024 * 2)) {
    //   this.setState({ profilePicUrl: undefined, profilePic: {value: this.props.user.profilePic, error: true, errorMessage: 'Image size is more that 2MB'}});
    // } else {
    //   this.setState({profilePic: {updatedValue: profilePic, value: this.props.user.profilePic, profilePicUrl: profilePicUrl, error: false, errorMessage: ''}});
    // }
    if (profilePic) {
      if (profilePic.size > 1024 * 1024 * 2) {
        this.setState({
          fileError: true,
          errorMessage: "Please upload a file that is smaller than 2 MB.",
        });
      } else if (!isValidExtension(profilePic, ["jpg", "png"])) {
        this.setState({
          fileError: true,
          errorMessage: "Please select only .jpg or .png file.",
        });
      } else {
        this.setState({
          profilePic: profilePic,
          profilePicUrl: profilePicUrl,
          fileError: false,
          errorMessage: "",
        });
      }
    }
  };

  handleDateChange = (date) => {
    // console.log(date)
    if (date) {
      this.setState({ birthDate: moment(date) });
    } else {
      this.setState({ birthDate: null });
    }
  };

  renderFieldOptions = (option) => {
    let target = `${option.value}${this.props.label}`;
    return (
      <TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.label}
        type="light"
        place="left"
        delayShow={500}
      />
    );
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  render() {
    // console.log(this.props.user.profile);
    const { profile } = this.props.user;
    const { details } = this.props.office;
    const {
      formError,
      fileError,
      errorMessage,
      firstName,
      lastName,
      formErrorFields,
      disability,
      occupation,
      birthDate,
      seniority,
      religion,
      veteran,
      sexualOrientation,
      ethnicity,
      gender,
      title,
      profilePhoto0,
      profilePhoto1,
      profilePhoto2,
      profilePhoto3,
      genderPronoun,
      address,
      location,
      mobileNumber,
      collapseOpen,
    } = this.state;

    // let userPicPlaceholders = [profilePhoto0, profilePhoto1, profilePhoto2, profilePhoto3];

    // console.log(this.state);
    let officeSteps = officeSetupSteps;
    if (profile.role === "Member") {
      officeSteps = [];
    }

    const accordionUI = () => {
      return (
        <div>
          
          <div className="row" style={{ marginTop: 25 }}>
            <div className={`${isMobile ? "pl-4 pr-3 mb-2" : "textbox-lable"}`}>
              {/* <Label for="title" className="field-lable">
        Title 
      </Label> */}

              <div
                className={`${
                  isMobile ? "pl-4 mb-3" : "text-right profile-modal-label"
                }`}
              >
                <div className="text-right profile-modal-label">Title</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
            </div>
            <div className={`${isMobile && "pl-4"} textbox-field `}>
              <Input
                type="text"
                name="title"
                value={title}
                invalid={formError && formErrorFields.indexOf("title") > -1}
                placeholder="Provide your current formal title in your primary organizational role"
                onChange={this.handleInputChange}
              />
              {formError && formErrorFields.indexOf("title") > -1 && (
                <div className="input-error-msg-field">
                  Please enter your title
                </div>
              )}
            </div>
          </div>

          <div className="row text-muted font-italic">
            <div className="textbox-lable"></div>
          </div>
          <Row className={`${!isMobile && "mlmr0"} mt20`}>
            <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
              <div className="text-right profile-modal-label">Occupation</div>
              <div className="profile-modal-optional-txt">(optional)</div>
            </div>
            <div className={`${isMobile && "pl-4"} textbox-field `}>
              <Select
                className="map-table-dropdown"
                searchable={!isMobile}
                placeholder="Select occupation"
                value={occupation.value}
                clearable={false}
                optionRenderer={this.renderFieldOptions}
                options={occupation.options.sort(function(a, b) {
                  if (a.label < b.label) return -1;
                  else if (a.label > b.label) return 1;
                  return 0;
                })}
                valueKey="value"
                labelKey="label"
                onChange={(e) => this.updateDiversity(e, occupation)}
              />
            </div>
          </Row>

          <Row className={`${!isMobile && "mlmr0"} mt20`}>
            <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
              <div className="text-right profile-modal-label">Job Category</div>
              <div className="profile-modal-optional-txt">(optional)</div>
            </div>
            <div className={`${isMobile && "pl-4"} textbox-field `}>
              <Select
                className="map-table-dropdown"
                searchable={!isMobile}
                placeholder="Select job category"
                value={seniority.value}
                clearable={false}
                optionRenderer={this.renderFieldOptions}
                options={seniority.options.sort(function(a, b) {
                  if (a.label < b.label) return -1;
                  else if (a.label > b.label) return 1;
                  return 0;
                })}
                valueKey="value"
                labelKey="label"
                onChange={(e) => this.updateDiversity(e, seniority)}
              />
            </div>
          </Row>

          {/* <div className="row" style={{marginTop:25}}>
      <div className="textbox-lable">
        <div style={{float:'right'}}>
          <Label className="field-lable mb0" for="departmentPosition" >DEI Role</Label>
          <div className="optional-text">(optional)</div>
        </div>

      </div>




      <div className="textbox-field">



       <div className="inner-addon right-addon">
          <span className="diRole-max-length-hint">{this.state.dIRole.length}/250</span>
          <Input type="textarea"
            name="dIRole"
            style={{height:'115px'}}
            minLength="0"
            maxLength="250"
            value={this.state.dIRole}
            placeholder="Provide a summary of how you are currently contributing (or plan to contribute ) to your organization's Diversity and Inclusion goals?"
            onChange={this.handleInputChange} />
       </div>
      </div>
    </div> */}

          <If condition={!isMobile}>
            <div className="mt20 mb20">
              <Alert color="info">
                <span className="alert-info-text">
                  <span className="alert-info-icon"></span>
                  {isTrivvyProduct() ? (
                    <span>
                      Please self-identify below regarding your gender,
                      ethnicity, sexual orientation, veteran status, disability,
                      age and religion. This information is private to you, and
                      is never disclosed to other users, your employer or anyone
                      else. It is used only for purposes of understanding the
                      demographics of our users. You can edit the information at
                      any time.
                    </span>
                  ) : (
                    <span>
                      Please self-identify below regarding your gender,
                      ethnicity, sexual orientation, veteran status, disability,
                      age and religion. This information is private to you, and
                      is never disclosed to other users, your employer or anyone
                      else. It is used only for purposes of improving your own
                      experience on this platform, and creating anonymously
                      aggregated benchmarks to improve diversity, inclusion and
                      belonging in your organization. You can edit the
                      information at any time.
                    </span>
                  )}
                </span>
              </Alert>
            </div>
          </If>

          <div>
            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">
                  Date of Birth
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <div className="inner-addon right-addon">
                  {/* <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("selectFileDate")} /> */}
                  <DatePicker
                    id="selectFileDate"
                    placeholderText="Enter birth date"
                    className="input-custom-date form-control"
                    showYearDropdown
                    onChange={this.handleDateChange}
                    selected={birthDate ? moment(birthDate) : null}
                    maxDate={moment()}
                  />
                </div>
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">Gender</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select gender"
                  value={gender.value}
                  clearable={false}
                  options={gender.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, gender)}
                  // onChange={(event)=> this.setState({gender: { value: {value:event.target.value, label:event.target.value}}}) }
                />
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">Ethnicity</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select ethnicity"
                  value={ethnicity.value}
                  clearable={false}
                  optionRenderer={this.renderFieldOptions}
                  options={ethnicity.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, ethnicity)}
                />
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">
                  Sexual Orientation
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select sexual orientation"
                  value={sexualOrientation.value}
                  clearable={false}
                  optionRenderer={this.renderFieldOptions}
                  options={sexualOrientation.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, sexualOrientation)}
                />
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">
                  Veteran Status
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select veteran type"
                  value={veteran.value}
                  clearable={false}
                  options={veteran.options}
                  optionRenderer={this.renderFieldOptions}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, veteran)}
                />
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">Disability</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select disability type"
                  value={disability.value}
                  clearable={false}
                  options={disability.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  optionRenderer={this.renderFieldOptions}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, disability)}
                />
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">Religion</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select religion"
                  value={religion.value}
                  clearable={false}
                  options={religion.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  optionRenderer={this.renderFieldOptions}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) => this.updateDiversity(e, religion)}
                />
              </div>
            </Row>

            <Row className={`${!isMobile && "mlmr0"} mt20`}>
              <div className={`${isMobile ? "pl-4 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">Pronouns</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-4"} textbox-field `}>
                <Select
                  className="map-table-dropdown"
                  searchable={!isMobile}
                  placeholder="Select gender pronoun"
                  value={genderPronoun.value}
                  clearable={false}
                  options={GENDER_PRONOUNS_OPTIONS}
                  valueKey="value"
                  labelKey="label"
                  onChange={(e) =>
                    this.setState({
                      genderPronoun: { ...genderPronoun, value: e.value },
                    })
                  }
                />
              </div>
            </Row>

            <Row className="mlmr0 mt20">
              <div className={`${isMobile ? "pl-2 mb-3" : "textbox-lable"}`}>
                <div className="text-right profile-modal-label">
                  Address (Location)
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </div>
              <div className={`${isMobile && "pl-2"} textbox-field `}>
                <AutocompleteAddress
                  address={this.state.address.value}
                  handleSelect={(address, lng, lat) => {
                    console.log("first", address);
                    this.setState({
                      address: { ...this.state.address, value: address },
                    });
                    this.setState({
                      location: {
                        ...this.state.location,
                        value: {
                          type: "Point",
                          coordinates: [lng, lat],
                        },
                      },
                    });
                  }}
                  relative
                  delayClose
                />
              </div>
            </Row>
          </div>
        </div>
      );
    };
    return (
      <div className="page-title-box newUserDetailsContainer">
        <If condition={!isMobile}>
          <div className="recentUsers centerText">{this.renderUsers()}</div>
          <div className="title-text">Profile Information</div>
          {this.props.user.profile.role == "Member" ||
          this.props.user.profile.organizationId.isSetupSkipped ? (
            <hr className="separator-line" />
          ) : (
            <Steps steps={officeSteps} currentStep={1} />
          )}
          {formError ? (
            <div className="alert-msg-bg mt50">
              <i className="close-icon">close</i>
              <div className="d-flex custom-message-box">
                <i className="material-icons alert-icon-bg font18">
                  remove_circle
                </i>
                <span className="message-sub-text ml20">
                  There were some errors with your form. Please fix the
                  highlighted fields below.
                </span>
              </div>
            </div>
          ) : null}

          {isTrivvyProduct() ? (
            <div className="mb20 mt20">
              Please provide your basic information below.
            </div>
          ) : (
            <div className="mb20 mt20">
              Please provide your basic information below. Note that while this
              information is visible to other users, you can always post
              anonymously, if you prefer. You can edit the information at any
              time.
            </div>
          )}
        </If>

        <div className="row mb20 mt20">
          <If condition={!isMobile}>
            <div className="textbox-lable">
              <div style={{ float: "right" }}>
                <Label
                  className="field-lable mb0 formicon"
                  style={{
                    display: "block !important",
                    width: "100% !important",
                  }}
                  for="photo"
                >
                  Photo
                </Label>
                <div
                  className="optional-text formhinttext"
                  style={{
                    display: "block !important",
                    width: "100% !important",
                  }}
                >
                  (optional)
                </div>
              </div>
            </div>
          </If>

          <div className="img-container marginLeft30">
            {profilePicValidityCheck(this.state.profilePicUrl) ? (
              <img
                src={this.state.profilePicUrl}
                className="officemate-profile-img"
              />
            ) : (
              <span
                className="spotlightUserInitials"
                data-letters={
                  firstName && lastName
                    ? this.getInitials({ firstName, lastName })
                    : ""
                }
              />
            )}

            <div className="middle">
              <div className="text d-flex align-items-center justify-content-center">
                <label
                  htmlFor="profile-pic-file-input"
                  style={{ marginBottom: "0px" }}
                >
                  <span
                    className="cursor-pointer edit-txt "
                    style={{ color: "white" }}
                  >
                    edit
                  </span>
                </label>
                <input
                  id="profile-pic-file-input"
                  onChange={this.handleProfilePicUpload}
                  type="file"
                  // accept="image/png, image/jpeg"
                />
              </div>
            </div>
          </div>

          {/* </div> */}
          {fileError ? (
            <div className="input-error-msg-field">{errorMessage}</div>
          ) : null}
        </div>

        <div className="row">
          <div className={`${isMobile ? "pl-4 mb-2" : "textbox-lable"}`}>
            <Label for="firtName" className="field-lable">
              First Name
            </Label>
          </div>
          <div className={`${isMobile && "pl-4 mb-2"} textbox-field `}>
            <Input
              type="text"
              placeholder="Provide your full first name"
              value={firstName}
              name="firstName"
              onChange={this.handleInputChange}
              invalid={formError && formErrorFields.indexOf("firstName") > -1}
            />
            {formError && formErrorFields.indexOf("firstName") > -1 && (
              <div className="input-error-msg-field">
                Please remove any numbers or special characters.
              </div>
            )}
          </div>
        </div>
        <div className="row" style={{ marginTop: 25 }}>
          <div className={`${isMobile ? "pl-4 mb-2" : "textbox-lable"}`}>
            <Label for="lastName" className="field-lable">
              Last Name
            </Label>
          </div>
          <div className={`${isMobile && "pl-4"} textbox-field `}>
            <Input
              type="text"
              placeholder="Provide your full last name"
              value={lastName}
              name="lastName"
              invalid={formError && formErrorFields.indexOf("lastName") > -1}
              onChange={this.handleInputChange}
            />
            {formError && formErrorFields.indexOf("lastName") > -1 && (
              <div className="input-error-msg-field">
                Please remove any numbers or special characters.
              </div>
            )}
          </div>
        </div>
        <div className="row" style={{ marginTop: 25 }}>
          <div className={`${isMobile ? "pl-4 mb-2" : "textbox-lable"}`}>
            <div className="float-right">
              <Label for="lastName" className="field-lable">
                Mobile Number
              </Label>

              <div
                className="optional-text formhinttext"
                style={{
                  textAlign: "right",
                }}
              >
                (optional)
              </div>
            </div>
          </div>
          <div className={`${isMobile && "pl-4"} textbox-field `}>
            <PhoneInput
              placeholder="Enter phone number"
              value={mobileNumber}
              onChange={(v) =>{
               
                this.setState({
                  mobileNumber: formatPhoneNumber(v),
                })
              }
              }
              className="form-control p-0 pl-2"
              defaultCountry="US"
            />
          </div>
        </div>

        <div className="row" style={{ marginTop: 25 }}>
            <div className={`${isMobile ? "pl-4 pr-3 mb-2" : "textbox-lable"}`}>
              <Label for="email" className="field-lable">
                Email
              </Label>
            </div>
            <div className={`${isMobile && "pl-4"} textbox-field `}>
              <Input
                type="email"
                name="email"
                placeholder="example@example.com"
                value={profile.email}
                readOnly
              />
            </div>
          </div>

        {/* {!isTrivvyProduct() ? (
          accordionUI()
        ) : ( */}
          <div>
            <div
              className={collapseOpen? "accordion-flush":"acccordion-plain"}
              onClick={() => {
                this.setState({
                  collapseOpen: !collapseOpen,
                });
              }}
            >
              <div className="pl-3 pr-3 d-flex justify-content-between w-100">
              <Label for="lastName" className="field-lable">
               Other Profile Attributes
              </Label>
                <span>
                  {collapseOpen ? (
                    <BsChevronUp size={24} color="gray" />
                  ) : (
                    <BsChevronDown size={24} color="gray" />
                  )}
                </span>
              </div>
            </div>
            <Collapse isOpen={collapseOpen}>{accordionUI()}</Collapse>
          </div>
         {/* )} */}

        <div className="row mb10 mt-5">
          <div className="col">
            <Button
              color="primary"
              onClick={this.handleContinue}
              className={`${isMobile ? "mt-5" : ""} btn-continue`}
            >
              Continue
              <img
                style={{ marginLeft: "10px" }}
                src={rightArrow}
                height="25px"
                width="25px"
              />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    office: state.office,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(PersonalDetails, axios));
